import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import YoutubePlayer from '../../common/YoutubePlayer';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>HR Network Platform</h1>
			<p className='project-popup__description '>
				This platform was developed to help enterprise clients find IT specialists.
				Any user can register oneself on the HR Network platform and fill out a
				special questionnaire with experience details. Then the user should wait for
				notifications from recruiters. These submitted resumes are searchable per a
				number of filters, making it easy for recruiters to find a candidate from a
				specific location or skill set. <br />I rebuilt the server-side part of the
				application using Node.js, Express, and MongoDB. As well, I implemented
				Multilingual Support. On the front-end, I did a substantial facelift for
				jQuery code and introduced a mobile responsive layout for the website to
				display on various devices correctly. Implemented email layouts, integrated
				the platform with Amazon Email Service (AWS SES), and set up automatic
				mailing to users.
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						JavaScript, JQuery, SCSS, responsive web, Node.js + express, Mongo.db,
						AWS (EC2, Amazon SES)
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/e7IGvqlqV7Y'
					title='Platform for IT recruiters'
				/>
			</div>
			<div className='project-popup__images '>
				<p className='image-description image-description--left '>
					Client's feedback from my{' '}
					<a
						href='https://www.upwork.com/freelancers/~019846d9384d3f1d18'
						target='_blank'
						rel='noopener noreferrer'
					>
						Upwork
					</a>{' '}
					account:{' '}
				</p>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/hrnetwork/feedback/feedback.webp',
						backupImage: './media/projects/hrnetwork/feedback/feedback.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => (
						<img
							src={src}
							alt="CSV parser client's feedback"
							style={{
								border: '2px solid rgb(244, 244, 244)',
								padding: '5px 0 10px 0',
							}}
						/>
					)}
				</ProgressiveImage>
			</div>
			<div className='project-popup__buttons '>
				<a
					href='http://www.hrnetwork.club'
					className='project-link'
					target='_blank'
					rel='noopener noreferrer'
				>
					Visit project
				</a>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
